import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import {useSetupSummary} from "../../common/hooks/useSetupSummary";
import {
    getDefaultSyncNavRoute,
    isSyncNavRouteVisible,
} from "../../common/helpers/syncNavModules";

type SyncNavGuardProps = {
    children: React.ReactNode;
};

/** V2: redirect away from log routes for disabled sync modules. */
const SyncNavGuard: React.FC<SyncNavGuardProps> = ({children}) => {
    const location = useLocation();
    const {setup, loading, isV2} = useSetupSummary();

    if (!isV2 || loading) {
        return <>{children}</>;
    }

    if (!isSyncNavRouteVisible(location.pathname, setup)) {
        return <Redirect to={getDefaultSyncNavRoute(setup)}/>;
    }

    return <>{children}</>;
};

export default SyncNavGuard;
